<template>
  <v-container>
    <v-row>
      <v-col>
        <v-btn
          outlined
          color="primary"
          @click="downloadDbStructure"
          :disabled="isLoading"
        >
          <v-icon v-if="isLoading">mdi-loading mdi-spin</v-icon>
          <span v-else>
            <v-icon left>mdi-download</v-icon>
            Download Problem Information
          </span>
          <!-- <v-icon left>mdi-download</v-icon> -->
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import apiClient from "@/plugins/apiService";

export default {
  props: ["selectedProblem"],
  data() {
    return {
      isLoading: false,
    };
  },
  methods: {
    async downloadDbStructure() {
      try {
        this.isLoading = true;

        // Make GET request with selected problem
        const response = await apiClient.get(
          `/download-db-structure/${this.selectedProblem}`
        );
        const dbStructure = response.data;

        // Convert to JSON and create a file for download
        const blob = new Blob([JSON.stringify(dbStructure, null, 2)], {
          type: "application/json",
        });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "db_structure.json");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        this.isLoading = false;
      } catch (error) {
        console.error("Error downloading DB structure:", error);
        alert("Failed to download DB structure.");
        this.isLoading = false;
      }
    },
  },
};
</script>

<style scoped>
.v-btn {
  margin-top: 20px;
}
</style>
